import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-g01-content" }
const _hoisted_2 = { class: "p-the-g01-content__button_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_G01ContentButtonList = _resolveComponent("G01ContentButtonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_G01ContentButtonList, {
        categories: _ctx.categories,
        "is-category": _ctx.isCategory
      }, null, 8, ["categories", "is-category"]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}